import Vue from 'vue';
import App from './app.vue';
import router from './router';
import 'amfe-flexible/index';

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
Vue.config.productionTip = false;

if (isMobile) {
  const hash = window.location.hash || '';
  window.location.href = `https://www.eidtokencloud.com/mobile/index.html${hash}`;
} else {
  new Vue({
    router,
    render: (h) => h(App),
  }).$mount('#app');
}
